module.exports = __webpack_public_path__ + "img/cover.26c250a8.jpg";